import "./AgentScoringRulePageRoute.less";

import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { GuxRadialLoading } from "genesys-spark-components-react";
import AgentScoringRulePage from "features/agentScoringRules/AgentScoringRulePage";
import pageStrings from "features/agentScoringRules/AgentScoringRulePage.strings";
import { useStrings } from "features/i18n/useStrings";
import { useAgentScoringRuleNavigation } from "features/agentScoringRules/useAgentScoringRuleNavigation";
import {
    selectCanAddScoringRule,
    selectCanEditScoringRule,
} from "features/auth/currentUserSlice";
import { useAppSelector } from "app/hooks";
import agentScoringRulesToasts from "features/agentScoringRules/agentScoringRulesToasts";
import { NotFound } from "./NotFound";

/**
 * Rule editor route. Create (`/agentScoringRule`, no id) requires
 * quality:scoringRule:add; edit (`/agentScoringRule/:ruleId`) requires
 * quality:scoringRule:edit. Unauthorized deep-links toast and return to the list.
 */
export function AgentScoringRulePageRoute() {
    const { programId, ruleId } = useParams();
    const { openList } = useAgentScoringRuleNavigation(programId ?? "");
    const t = useStrings(pageStrings);
    const canAdd = useAppSelector(selectCanAddScoringRule);
    const canEdit = useAppSelector(selectCanEditScoringRule);
    const [hasHandledDenied, setHasHandledDenied] = useState(false);

    const isNew = !ruleId;
    const isAllowed = isNew ? canAdd : canEdit;

    useEffect(() => {
        if (!programId || isAllowed || hasHandledDenied) {
            return;
        }
        agentScoringRulesToasts.accessDenied();
        setHasHandledDenied(true);
        openList();
    }, [programId, isAllowed, hasHandledDenied, openList]);

    if (!programId) {
        return <NotFound />;
    }

    // Keep a spinner up while toast + openList() run — especially for the host
    // navHelper path, which can be async and would otherwise flash a blank page.
    if (!isAllowed) {
        return (
            <div className="AgentScoringRulePageRoute-loading" role="status">
                <GuxRadialLoading screenreaderText={t.labels.loading} />
            </div>
        );
    }

    return (
        <AgentScoringRulePage
            programId={programId}
            ruleId={isNew ? undefined : ruleId}
            onClose={() => openList()}
        />
    );
}

export default AgentScoringRulePageRoute;
